<template>
  <WsButtonWithPopup001
    width-stretch
    text-label="匯出"
    leading-icon="icon-cloud-download"
    :btn-list="list"
    @btn-click="$emit('createSubmit', $event)"
  />
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          text: "匯出 PDF",
          value: "pdf",
          id: 1,
        },
        {
          text: "匯出 xlsx",
          value: "xlsx",
          id: 2,
        },
        {
          text: "匯出 csv",
          value: "csv",
          id: 3,
        },
      ],
    }
  },
}
</script>